import { AbstractIdbaModel } from "src/app/shared/models/abstract-idba-model";

export class Deposito extends AbstractIdbaModel {
  public override convertToModel(data: any): AbstractIdbaModel {
    return new Deposito(data);
  }
  public display(self: any): string {
    if (self)
      self.displayWith = self && self.codigoDeposito && self.nomeDeposito ? `${self.codigoDeposito} - ${self.nomeDeposito}` : '';
    return self && self.codigoDeposito ? `${self.codigoDeposito} - ${self.nomeDeposito}` : '';
  }
  public displayCodigo(self: any): string {
    return self && self.codigoDeposito ? `${self.codigoDeposito}` : '';
  }
  public displayNome(self: any): string {
    return self && self.nomeDeposito ? `${self.nomeDeposito}` : '';
  }
  public filter(value: string, objectList: any[]): any[] {
    const filterValue = value.toLowerCase();
    return objectList.filter((item) =>
      item.codigoDeposito.toString().toLowerCase().includes(filterValue) ||
      item.nomeDeposito.trim().toLowerCase().includes(filterValue)
    );
  }


  nomeLocal: string;
  codigoDeposito: number;
  nomeDeposito: string;
  codigoLocal: Number;
  indTipoControleEstoque: number;
  codigoDepositoPadrao: number;
  nomeDepositoPadrao: string;

}
